import { v4 as uuidv4 } from 'uuid';
import { IHeaderRequest } from '../EGerdauService/types';
import { CookiesKey } from './enum';
import { getValueCookie } from './utils';
import { EGerdauService } from '../EGerdauService';

export const useAuth = () => {
  const getHeaders = (): IHeaderRequest => {
    const token = getValueCookie(CookiesKey.ACCESS_TOKEN);
    const client_id = process.env.REACT_APP_oauthClientID as string;
    const client_secret = process.env.REACT_APP_oauthClientSecret as string;
    const ssoAccess = getValueCookie(CookiesKey.SSO_ACCESS);
    const authorization_token = getValueCookie(CookiesKey.AUTHORIZATION_TOKEN);
    const profile_access_token = getValueCookie(
      CookiesKey.PROFILE_ACCESS_TOKEN
    );
    const current_correlation_id = getValueCookie(CookiesKey.CORRELATION_ID);

    const correlation_id =
      current_correlation_id ?? EGerdauService.setCorrelationId(uuidv4());

    return {
      Authorization: `Bearer ${authorization_token}`,
      client_id,
      client_secret,
      sso_access: `${ssoAccess}`,
      authorization_token: `${authorization_token}`,
      'Profile-Access-Token': `Bearer ${profile_access_token ?? token}`,
      'x-correlation-id': `${correlation_id}`
    };
  };

  return {
    getHeaders
  };
};
